import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import "./visitor-form";

@customElement("cg-visitor-details-screen")
export class CGVisitorDetailsScreen extends LitElement {
  static override styles = css`
    :host {
      display: block;
      height: 100%;
      background: var(--cg-bg);
      display: flex;
      flex-direction: column;
    }

    .header {
      display: flex;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid var(--cg-border);
      gap: 12px;
    }

    .back-btn {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      border: none;
      background: transparent;
      color: var(--cg-text);
      cursor: pointer;
      display: grid;
      place-items: center;
      transition: background-color 120ms ease;
    }

    .back-btn:hover {
      background: rgba(0, 0, 0, 0.05);
    }

    .title {
      font-weight: 600;
      font-size: 15px;
      color: var(--cg-text);
    }

    .content {
      flex: 1;
      padding: 24px 16px;
      overflow-y: auto;
    }
  `;

  @property({ attribute: false }) onBack?: () => void;
  @property({ attribute: false }) onSubmit?: (name: string, email: string) => void;

  override render() {
    return html`
      <div class="header">
        <button class="back-btn" @click=${this.onBack}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m15 18-6-6 6-6"/>
          </svg>
        </button>
        <div class="title">Visitor Details</div>
      </div>
      
      <div class="content">
        <cg-visitor-form 
          variant="full"
          @submit-details=${(e: CustomEvent) => this.onSubmit?.(e.detail.name, e.detail.email)}
        ></cg-visitor-form>
      </div>
    `;
  }
}
